<template>
  <div>
    <h4 class="primary--text">Crea Tag</h4>
    <br>
    <v-text-field
      outlined
      ref="newTag"
      v-model="value"
      label="Nuovo tag"
    ></v-text-field>
    <v-btn
      color="accent"
      @click="submit()"
    >
      Salva Tag
    </v-btn>

    <!-- Snackbar -->
    <v-snackbar
      right
      multi-line
      :color="snackbarColor"
      v-model="snackbar"
    >
      <b>
        <span v-if="errors">{{snackbarText}}</span>
        <span v-else>{{snackbarText}}</span>
      </b>
      <v-btn
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar><!-- /Snackbar -->
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'TagCreate',
    data() {
      return {
        value: '',
        errors: false,
        snackbar: false,
        snackbarText: null,
      }
    },
    methods: {
      ...mapActions([
        'createTag',
      ]),
      submit() {
        if (this.value.length !== 0) {
          this.createTag(this.value.toLowerCase())
            .then(res => {
              if (res.status === 200) {
                this.value = ''
                this.errors = false
                this.snackbar = true
                this.snackbarText = 'Tag creato!'
              } else {
                this.errors = true
                this.snackbar = true
                this.snackbarText = 'Problema nel salvataggio del tag..'
              }
            })
        } else {
          this.errors = true
          this.snackbar = true
          this.snackbarText = 'Non puoi creare un tag vuoto..'
        }
      }
    },
    computed: {
      snackbarColor() {
        return this.errors ? 'pink' : 'primary'
      }
    }
  }
</script>